import { useIntl } from "react-intl";
import color from "src/design-system/tokens/color";
import { spacing } from "src/design-system/tokens/spacing";
import styled from "styled-components";
import { Button } from "src/design-system/components/Button/Button";
import { messages } from "./ShowMoreButton.messages";

type ShowMoreButtonProps = {
  onOpenClick: () => void;
  onCloseClick: () => void;
  numResults: number;
  searchResultsLength: number;
  index?: number;
};

export function ShowMoreButton(props: ShowMoreButtonProps) {
  const intl = useIntl();

  return (
    <ButtonWrapper>
      {props.numResults < props.searchResultsLength ? (
        <Button
          variant="secondary"
          size="large"
          onPress={props.onOpenClick}
          data-testid={`show-more-${props.index ? `${props.index}` : "0"}`}
        >
          {intl.formatMessage(messages.showMoreResults, {
            count: props.searchResultsLength - props.numResults,
          })}
        </Button>
      ) : (
        <Button variant="secondary" size="large" onPress={props.onCloseClick}>
          {intl.formatMessage(messages.showLessResults)}
        </Button>
      )}
    </ButtonWrapper>
  );
}

export const ButtonWrapper = styled.div<{
  $isSearchPromo?: boolean;
}>`
  display: flex;
  transition: opacity 0.2s ease-in;
  margin: ${({ $isSearchPromo }) =>
    $isSearchPromo ? "0" : `${spacing.xl} 0 0`};

  // TODO: Add this button variant to the design system if this experiment graduates to the variant.
  & > button {
    width: 100%;
    border-color: transparent;
    background-color: ${color.primitive.neutral500};
    &:hover,
    &:active {
      background-color: ${color.primitive.neutral700};
      border-color: transparent;
    }
  }
`;
